import { N400 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { FirstImpressions } from '../../../../../model/side-information-component';

export const LayoutFirstImpressions = ({
  className,
  productListMsg,
  socialProof
}: FirstImpressions) => {
  const showSocialProofImage = socialProof.imgUrl && socialProof.imgUrl.length;
  return (
    <Root className={className}>
      <HeroImage src={socialProof.heroUrl} />
      <SocialProofText addBottomMargin={!showSocialProofImage}>
        {socialProof.text}
      </SocialProofText>
      {showSocialProofImage && <SocialProofImage src={socialProof.imgUrl} />}
      <FeatureList>
        <SanitizedFormattedHtmlMessage {...productListMsg} />
      </FeatureList>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
`;
const HeroImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;

const FeatureList = styled.div`
  margin: 0 auto;

  & ul {
    color: ${N400};
    font-weight: 100;
    font-size: clamp(1em, 2.5vw, 1.5em);
    list-style-type: none;
    margin: 0;
    padding-inline-start: 20px;
  }

  & li {
    font-size: 16px;
    margin: 8px 0;
    line-height: 1.5;
    list-style-image: url("data:image/svg+xml,%3Csvg width='13px' height='13px' viewBox='0 0 13 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate(0.000000, -51.000000)' stroke='%230049B0' stroke-width='1.6'%3E%3Cg transform='translate(1.000000, 45.000000)'%3E%3Cg transform='translate(0.000000, 0.416810)'%3E%3Cpolyline points='1.52655666e-16 11.9766645 3.98219585 17 11 7'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }

  & p {
    color: ${N400};
    font-weight: 100;
    font-size: 14px;
  }
`;

const SocialProofImage = styled.img`
  width: 100%;
`;

type SocialProofTextProps = {
  readonly addBottomMargin: boolean;
};
const SocialProofText = styled.p<SocialProofTextProps>`
  width: 100%;
  margin: ${(props) => (props.addBottomMargin ? '0 0 16px 0' : '0 0 0 0')};
  text-align: center;
  font-size: 1.25em;
  line-height: 1.1;
`;
